module.exports = __webpack_public_path__ + "static/media/8.6bb5f12b.jpg";